import { DeleteLockout } from './DeleteLockout'
import { CommonProps, LockoutActionsTypes } from './types'

export const modalsActions: Record<
  LockoutActionsTypes,
  React.FC<CommonProps>
> = {
  delete: DeleteLockout
}
